import newbornReducer from "./newbornReducer";

const caseInfoReducers = {
    newborn: newbornReducer
};

export default caseInfoReducers;